import { BehaviorSubject } from 'rxjs';
import { Session } from './Session';

export const sessionSubject = new BehaviorSubject<Session>({} as Session);
